import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Product } from './';

@Model()
export default class Price extends ApplicationRecord {
  static jsonapiType = 'prices';

  static scopeFactory() {
    return Price.includes([]);
  }

  @Attr() amount: string;
  @Attr() currency: string;
  @Attr() interval: string;
  @Attr() intervalCount: number;

  @HasOne() product: Product;
}
